import { render, staticRenderFns } from "./PackagesSidebar.vue?vue&type=template&id=73636da4&scoped=true&"
import script from "./PackagesSidebar.vue?vue&type=script&lang=js&"
export * from "./PackagesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PackagesSidebar.vue?vue&type=style&index=0&id=73636da4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73636da4",
  null
  
)

export default component.exports